module.exports = __webpack_public_path__ + "static/media/video.191ac574.svg";